import { Alert, AlertDescription, Button } from '@geely/ui';
import { AlertCircle } from 'lucide-react';
import { formatTime } from '@/lib/utils';
import type { ConflictErrorResponse } from '@/lib/api';

interface ConflictAlertProps {
  conflictError: ConflictErrorResponse;
  onSelectAlternativeTime: (time: string) => void;
}

export function ConflictAlert({ conflictError, onSelectAlternativeTime }: ConflictAlertProps) {
  if (!conflictError.data?.alternativeSlots) return null;

  return (
    <Alert className="mb-4 border-red-500 bg-red-50">
      <AlertCircle className="size-4 text-red-600" />
      <AlertDescription className="text-red-800">
        <p className="font-medium mb-2">
          O horário selecionado foi reservado por outra pessoa.
        </p>
        <p className="text-sm mb-2">Horários alternativos disponíveis:</p>
        <div className="flex flex-wrap gap-2">
          {conflictError.data.alternativeSlots.map((slot: { time: string }) => (
            <Button
              key={slot.time}
              size="sm"
              variant="outline"
              className="border-red-300 hover:bg-red-100"
              onClick={() => onSelectAlternativeTime(slot.time)}
            >
              {formatTime(slot.time)}
            </Button>
          ))}
        </div>
      </AlertDescription>
    </Alert>
  );
}
